import { defaultTheme } from 'react-admin';
import merge from 'lodash/merge';

const theme = merge({}, defaultTheme, {
    //...
});

export default theme;